import { gql } from "@apollo/client";

export const GET_INDICACION_INSUMO = gql`
  query getIndicacionInsumo($idIndicacion: Int!) {
    indicacionInsumo(idIndicacion: $idIndicacion) {
      success
      error
      valorEsperado {
        idIndicacionInsumo
        idIndicacion
        idInsumoN
        insumo
        cantidad
        idUnidad
        unidad
      }
    }
  }
`;